import type { Asset } from '@shared/types'

/**
 * P10-2 (docs/P10_PHASE2.md §2 item 2, 担当A): user-facing display name for
 * an Asset. `label` (set via `PATCH /api/assets/:id`) takes priority when
 * present; `filename` itself is immutable and always stays the fallback —
 * every caller that used to render `asset.filename` directly should go
 * through this instead so renaming an asset is visible everywhere at once
 * (asset bin card/list, search, name-sort, timeline block label).
 */
export function assetDisplayName(asset: Pick<Asset, 'filename' | 'label'>): string {
  return asset.label ?? asset.filename
}
